import React from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import ErrorBoundary from 'components/common/ErrorBoundary';
import Heading from 'components/Heading';
import AllNotification from './components/AllNotification';

const Notifications = () => {
  return (
    <div className="notifications-page">
      <div className="mb-3 pb-1 top-head">
        <Heading title="Notification" />
      </div>
      <Row>
        <Col xl={12}>
          <Card className="card-box border-0 page-card-box">
            <CardBody>
              <ErrorBoundary>
                <AllNotification />
              </ErrorBoundary>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Notifications;
